<template>
  <div class="inline-flex">
    <div :id="id" aria-label="Sign in with Google"></div>
  </div>
</template>

<script setup>
import { onMounted, onBeforeUnmount } from 'vue'
import AuthService from '@/service/authService'

const props = defineProps({
  remember: { type: Boolean, default: true },
  size: { type: String, default: 'large' }
})
const emit = defineEmits(['success', 'error'])
const id = 'google-btn-' + Math.random().toString(36).slice(2)

function handleCredentialResponse(response) {
  AuthService.loginWithGoogleIdToken(response.credential, props.remember)
    .then((data) => emit('success', data))
    .catch((e) => emit('error', e?.response?.data?.message || 'Google login failed'))
}

function currentTheme() {
  return document.documentElement.classList.contains('dark') ? 'filled_black' : 'filled_blue'
}

function renderButton() {
  const el = document.getElementById(id)
  if (!el || !window.google?.accounts?.id) return
  el.innerHTML = ''
  window.google.accounts.id.renderButton(el, {
    type: 'icon',
    shape: 'circle',
    theme: currentTheme(),
    size: props.size
  })
}

function initGoogle(clientId) {
  window.google.accounts.id.initialize({
    client_id: clientId,
    callback: handleCredentialResponse
  })
  renderButton()
}

let themeObserver
onMounted(() => {
  const clientId = AuthService.getGoogleClientId()
  if (!clientId) return emit('error', 'Google Client ID não configurado.')

  const loadAndInit = () => initGoogle(clientId)

  if (!window.google?.accounts?.id) {
    const script = document.createElement('script')
    script.src = 'https://accounts.google.com/gsi/client?hl=en'
    script.async = true
    script.defer = true
    script.onload = loadAndInit
    document.head.appendChild(script)
  } else {
    loadAndInit()
  }

  themeObserver = new MutationObserver(() => renderButton())
  themeObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] })
})

onBeforeUnmount(() => {
  themeObserver?.disconnect?.()
})
</script>